import { jsx } from "panel";
import { WarningEl } from "common/components/warning";
import { ButtonEl } from "common/components/button";
import { ButtonSize } from "common/components/button/constants";
import { WarningHeroReportName, WarningHeroTheme } from "./constants";
function EmptyFunnelWithVideo({
  report,
  onFeedBackButtonClicked
}) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".empty-report-with-video"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".header"
  }, report === WarningHeroReportName.Funnels ? /* @__PURE__ */ jsx("h1", {
    sel: ".header-heading"
  }, "New ways to answer questions in Funnels!") : /* @__PURE__ */ jsx("h1", {
    sel: ".header-heading"
  }, "New ways to answer questions in Retention!"), /* @__PURE__ */ jsx("p", {
    sel: ".header-content"
  }, "Some capabilities have moved, others got an upgrade.")), /* @__PURE__ */ jsx("div", {
    sel: ".container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".video"
  }, /* @__PURE__ */ jsx("div", {
    style: { position: `relative`, paddingBottom: `62.5%`, height: `0` }
  }, /* @__PURE__ */ jsx("iframe", {
    attrs: {
      src: report === WarningHeroReportName.Funnels ? `https://www.loom.com/embed/7905e588beea48c5bc757ce8c43aae8b?sid=7ee9d232-e2c1-4c4d-b084-e452430e2e50` : `https://www.loom.com/embed/45ddc28851aa494ead99bccafe1f9a37?sid=590ce64f-3a8a-44b7-9e05-eef84ef3227a`,
      frameborder: `0`,
      webkitallowfullscreen: true,
      mozallowfullscreen: true,
      allowfullscreen: true
    },
    style: { position: `absolute`, top: `0`, left: `0`, width: `100%`, height: `100%`, borderRadius: `24px` }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, report === WarningHeroReportName.Funnels ? /* @__PURE__ */ jsx("p", {
    sel: ".content-new"
  }, "What's new") : /* @__PURE__ */ jsx("p", {
    sel: ".content-new"
  }, "What's changed"), report === WarningHeroReportName.Funnels ? /* @__PURE__ */ jsx("ul", {
    sel: ".content-list"
  }, /* @__PURE__ */ jsx("li", null, /* @__PURE__ */ jsx("b", null, "Time to Convert"), " is now available in filters and breakdown"), /* @__PURE__ */ jsx("li", null, /* @__PURE__ */ jsx("b", null, "Analyze Revenue"), " as it flows through your funnel"), /* @__PURE__ */ jsx("li", null, /* @__PURE__ */ jsx("b", null, "Measure Frequency"), " of actions between steps")) : /* @__PURE__ */ jsx("ul", {
    sel: ".content-list"
  }, /* @__PURE__ */ jsx("li", null, /* @__PURE__ */ jsx("b", null, "Define your Metric"), " by choosing events and a measurement"), /* @__PURE__ */ jsx("li", null, /* @__PURE__ */ jsx("b", null, "Choose your Visualization"), " from common chart types")), /* @__PURE__ */ jsx("div", {
    sel: ".button-container"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      icon: `share`,
      size: ButtonSize.Large,
      target: `_blank`,
      href: report === WarningHeroReportName.Funnels ? `https://docs.mixpanel.com/docs/reports/funnels#quick-start---new-funnels` : `https://docs.mixpanel.com/docs/reports/retention#quick-start`
    }
  }, "Learn More"), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { icon: `sms`, size: ButtonSize.Large },
    on: { click: onFeedBackButtonClicked }
  }, "Give Feedback")))));
}
export function template() {
  if (this.attr(`theme`) === WarningHeroTheme.EmptyReportWithVideo && (this.attr(`report`) === WarningHeroReportName.Funnels || this.attr(`report`) === WarningHeroReportName.Retention)) {
    return /* @__PURE__ */ jsx(EmptyFunnelWithVideo, {
      report: this.attr(`report`),
      onFeedBackButtonClicked: this.handleFeedBackButtonClicked
    });
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".warning-hero-container",
    style: this.attr(`margin-override`) ? { margin: `0px` } : {}
  }, /* @__PURE__ */ jsx(WarningEl, {
    attrs: {
      "cta-href": this.attr(`cta-href`),
      "cta-text": this.attr(`cta-text`),
      "header-text": this.attr(`header-text`),
      theme: this.helpers.getTheme(),
      "img-src": this.helpers.getImgSrc(),
      "body-text": this.helpers.getBodyText()
    },
    on: {
      ctaClick: this.helpers.handleCtaClick
    }
  }, /* @__PURE__ */ jsx("slot", null)));
}
